import { ApiSimpleComponent } from "@incendium/api";
import {
  DialogTitle,
  DialogContent,
  Box,
  Stack,
  ButtonGroup,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  Laptop,
  Tablet,
  PhoneAndroid,
} from "@mui/icons-material";
import { useState, useCallback } from "react";
import CustomDialog from "Components/CustomDialog/CustomDialog";
import LanderPreview from "./LanderPreview";

type ViewportSize = "desktop" | "tablet" | "mobile";

interface ILanderPreviewDialogProps {
  open: boolean;
  onClose: () => void;
  component: ApiSimpleComponent;
  title?: string;
  fullScreen?: boolean;
}

function LanderPreviewDialog({
  open,
  onClose,
  component,
  title,
  fullScreen,
}: ILanderPreviewDialogProps) {
  const [viewport, setViewport] = useState<ViewportSize>("desktop");

  const handleViewportChange = useCallback((size: ViewportSize) => {
    setViewport(size);
  }, []);

  const previewWidth =
    viewport === "tablet"
      ? 900
      : viewport === "mobile"
        ? 400
        : "100%";

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="xl"
      fullWidth
    >
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" alignItems="center" pr={4}>
          <Box>{title || "Preview"}</Box>
          <ButtonGroup
            variant="outlined"
            size="small"
          >
            <Tooltip title="Desktop">
              <IconButton
                color="inherit"
                sx={{
                  color: "white",
                  backgroundColor: viewport === "desktop" ? "rgba(255, 255, 255, 0.2)" : "transparent",
                }}
                onClick={() => handleViewportChange("desktop")}
              >
                <Laptop fontSize="small" color="inherit" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Tablet">
              <IconButton
                onClick={() => handleViewportChange("tablet")}
                sx={{
                  color: "white",
                  backgroundColor: viewport === "tablet" ? "rgba(255, 255, 255, 0.2)" : "transparent",
                }}
              >
                <Tablet fontSize="small" color="inherit" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Mobile">
              <IconButton
                onClick={() => handleViewportChange("mobile")}
                sx={{
                  color: "white",
                  backgroundColor: viewport === "mobile" ? "rgba(255, 255, 255, 0.2)" : "transparent",
                }}
              >
                <PhoneAndroid fontSize="small" color="inherit" />
              </IconButton>
            </Tooltip>
          </ButtonGroup>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            minHeight: "60vh",
            padding: 2,
            backgroundColor: "#f5f5f5",
          }}
        >
          <Box
            sx={{
              width: previewWidth,
              maxWidth: "100%",
              backgroundColor: "white",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              borderRadius: 1,
              overflow: "hidden",
            }}
          >
            <LanderPreview
              component={component}
              width={previewWidth}
              height="80vh"
              autoResize={true}
            />
          </Box>
        </Box>
      </DialogContent>
    </CustomDialog>
  );
}

export default LanderPreviewDialog;

